import Banner from '../components/Banner'
import CoinsTable from '../components/CoinsTable'

const HomePage = () => {
    return (
        <>
            <Banner />
            <CoinsTable />
        </>
    )
}

export default HomePage
